function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { range } from '../../utils';

// Returns a range of "middle" page numbers to show
export default function calculateMiddlePages(currentPage, min, max, numPagesShown) {
  if (min > max) throw new Error('Paginator: min must be <= max');
  // If no middle pages required, return empty array
  if (max === min) return [];
  // Get indices of first and last pages
  var _getFirstAndLastPages = getFirstAndLastPages(currentPage, min, max, numPagesShown),
    _getFirstAndLastPages2 = _slicedToArray(_getFirstAndLastPages, 2),
    firstPage = _getFirstAndLastPages2[0],
    lastPage = _getFirstAndLastPages2[1];
  // Generate range of page numbers
  return range(firstPage, lastPage + 1);
}
function getFirstAndLastPages(currentPage, min, max, numPagesShown) {
  // Don't overlap with min and max pages
  var lowestPossiblePage = min + 1;
  var highestPossiblePage = max - 1;
  // Default to showing all pages
  if (!numPagesShown) return [lowestPossiblePage, highestPossiblePage];
  // Calculate pages before and after current page
  var _getPagesAroundCurren = getPagesAroundCurrent(currentPage, numPagesShown),
    _getPagesAroundCurren2 = _slicedToArray(_getPagesAroundCurren, 2),
    firstPage = _getPagesAroundCurren2[0],
    lastPage = _getPagesAroundCurren2[1];
  // Trim to min and max
  if (firstPage < lowestPossiblePage) {
    // Offset last page but trim at upper limit
    var offsetLastPage = min + numPagesShown - 1;
    var trimmedLastPage = Math.min(highestPossiblePage, offsetLastPage);
    return [lowestPossiblePage, trimmedLastPage];
  }
  if (lastPage > highestPossiblePage) {
    // Offset first page but trim at lower limit
    var offsetFirstPage = max - numPagesShown + 1;
    var trimmedFirstPage = Math.max(lowestPossiblePage, offsetFirstPage);
    return [trimmedFirstPage, highestPossiblePage];
  }
  return [firstPage, lastPage];
}
function getPagesAroundCurrent(currentPage, numPagesShown) {
  // Calculate num pages to put to left and right of current page
  var pagesBeforeCurrent = Math.floor(numPagesShown / 2);
  var pagesAfterCurrent = numPagesShown - (pagesBeforeCurrent + 1);
  // Calculate first and last page
  var firstPage = currentPage - pagesBeforeCurrent;
  var lastPage = currentPage + pagesAfterCurrent;
  return [firstPage, lastPage];
}